export default __webpack_public_path__ + "static/media/cool-background.d6d82ee5.png";